import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import {
    ListItem, ListItemAvatar, ListItemSecondaryAction,
    ListItemText, Link, Avatar, IconButton
} from '@mui/material';
import Icon from '@mdi/react'
import { mdiPin, mdiPinOff, mdiPencil, mdiDelete, mdiMapMarkerRadius } from '@mdi/js';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import {
    addToPinnedMarker, removeFromPinnedMarker,
    setMarkerDetailView, removeMarkerDetailView,
    removeZoneDetailView, markerDetailViewSelector, editMarker, deleteMarker
} from '../../features/places/placesSlice';
import { resetFindLatLng, setMapControl, setNeedBounding } from '../../features/map/mapSlice';
const useStyles = makeStyles((theme) => ({
    active: {
        backgroundColor: 'LightYellow'
    },
    inactive: {
        backgroundColor: 'White'
    }

}));

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: useTheme().palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: useTheme().shadows[1],
        fontSize: 11,
    },
}));


const MarkerListItem = ({ markerId, pinned, setListViewCallback }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const markerDetailView = useSelector(markerDetailViewSelector);

    const markerData = useSelector(state => state.places.markers[`${markerId}`]);
    const [confirmOpen, setConfirmOpen] = useState(false);

    const togglePinned = () => {
        if (pinned) {
            dispatch(removeFromPinnedMarker(markerId));
        } else {
            dispatch(addToPinnedMarker(markerId));
        }
    }

    const toggleDetailView = () => {
        if (markerId === markerDetailView) {
            dispatch(removeMarkerDetailView());
            dispatch(setMapControl('asset'));
        } else {
            dispatch(removeZoneDetailView());
            dispatch(resetFindLatLng());
            dispatch(setMarkerDetailView(markerId));
            dispatch(setMapControl('marker'));
            dispatch(setNeedBounding(true));
        }
    }

    const handleDeleteMarker = () => {
        setConfirmOpen(true);
    }

    const confirmDeleteMarker = () => {
        dispatch(deleteMarker(markerId));
        setConfirmOpen(false);
    }

    const handleMarkerEdit = () => {
        //console.log("marker to edit", markerData);
        dispatch(editMarker(markerData));
        setListViewCallback('markerCreate');
    }

    return (
        <Fragment>
            <ListItem
                className={markerId === markerDetailView ? classes.active : classes.inactive}
            >
                <ListItemAvatar>
                    <Avatar className={markerId === markerDetailView ? classes.active : classes.inactive}>
                        {/*<img src={`/assets/history/def30/skyscraper.png`} alt="marker" />*/}
                        <Icon
                            path={mdiMapMarkerRadius}
                            title="Marker Delete"
                            size={0.8}
                            color={markerData.marker_color}
                        />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <Link href="#" onClick={toggleDetailView}>
                            <Typography variant="subtitle2" color='textPrimary'>
                                <span>
                                    <b>
                                        {markerData.marker_name}
                                    </b>
                                </span>
                            </Typography>
                        </Link>
                    }
                    secondary={markerData ? markerData.marker_tags ? markerData.marker_tags.length <= 1 ?
                        <Typography variant="subtitle2">{markerData.marker_tags[0]}</Typography>
                        :
                        <LightTooltip title={markerData.marker_tags.join(", ")}>
                            <Typography variant="subtitle2" >{markerData.marker_tags[0]} + {markerData.marker_tags.length - 1}</Typography>
                        </LightTooltip >

                        : null : null
                    }
                />
                <ListItemSecondaryAction>
                    <IconButton onClick={handleMarkerEdit} size="large">
                        <Icon
                            path={mdiPencil}
                            title="Marker Edit"
                            size={0.7}
                            color="DodgerBlue"
                        />
                    </IconButton>
                    <IconButton onClick={handleDeleteMarker} size="large">
                        <Icon
                            path={mdiDelete}
                            title="Marker Delete"
                            size={0.7}
                            color="Crimson"
                        />
                    </IconButton>
                    <IconButton onClick={togglePinned} size="large">
                        {
                            pinned ?
                                <Icon
                                    path={mdiPin}
                                    title="MarkerPin"
                                    size={0.7}
                                    color="SlateBlue"
                                />
                                :
                                <Icon
                                    path={mdiPinOff}
                                    title="MarkerPin"
                                    size={0.7}
                                    color="Grey"
                                />
                        }
                    </IconButton>
                </ListItemSecondaryAction>

            </ListItem>
            <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Delete Marker</DialogTitle>
                <DialogContent>
                    <Typography variant="body2">
                        Delete marker <b>{markerData?.marker_name || 'this marker'}</b>? This action cannot be undone.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
                    <Button onClick={confirmDeleteMarker} color="error" variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}

export default MarkerListItem;
